import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { ConfigService } from '../services/config.service';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const configService = inject(ConfigService);
  const token = configService.getToken();
  const user = configService.getUser();

  if (!token || !user) {
    router.navigate(['/']); // Redirect kalau gak ada token
    return false;
  }
  return true;
};
